/**
 * 🏅 Badge evolution helpers
 * --------------------------
 * Referral badges are stackable in storage (so we keep history), but on
 * public-facing chips we only want to show the HIGHEST tier the user has
 * earned. The backend exposes `highest_referral_badge` on /auth/me and
 * /artist/{id}; this helper produces a filtered list for any other call
 * site that has `referral_badges` but not the precomputed top tier.
 */

// Keep in sync with backend REFERRAL_BADGES order (low → high threshold).
export const REFERRAL_BADGE_LADDER = [
  "community_builder",
  "talent_scout",
  "rgm_ambassador",
  "ar_connector",
];
const _RANK = Object.fromEntries(
  REFERRAL_BADGE_LADDER.map((b, i) => [b, i + 1]),
);

export const isReferralBadge = (b) => Boolean(_RANK[b]);

export const highestReferralBadge = (badges) => {
  if (!Array.isArray(badges)) return null;
  let top = null;
  let topRank = 0;
  for (const b of badges) {
    const r = _RANK[b];
    if (r && r > topRank) { top = b; topRank = r; }
  }
  return top;
};

/**
 * Given an array of badge ids (e.g. `user.all_badges` or a card's
 * `user_badges`), return the same array with all referral-ladder badges
 * collapsed down to ONLY the top tier the user has reached. Non-referral
 * badges (founder, admin, verified_artist, etc.) pass through unchanged.
 */
export const evolveBadges = (badges) => {
  if (!Array.isArray(badges)) return [];
  const top = highestReferralBadge(badges);
  return badges.filter((b) => !isReferralBadge(b) || b === top);
};
